/**
 * Gera o link de navegacao baseado na plataforma do usuario
 *
 * @param {number} latitude
 * @param {number} longitude
 * @returns {string} URL de navegacao
 */
export function getLocationLink(latitude, longitude) {
  if (latitude == null || longitude == null) {
    return 'https://www.google.com/maps/place/IENA+El+Shaday'
  }

  const ua = navigator.userAgent || navigator.vendor || window.opera

  if (/iPhone|iPad|iPod/.test(ua)) {
    return `https://maps.apple.com/?q=IENA%20El%20Shaday&ll=${latitude},${longitude}`
  }

  if (/android/i.test(ua)) {
    return `geo:${latitude},${longitude}?q=${latitude},${longitude}(IENA El Shaday)`
  }

  return `https://www.google.com/maps/place/IENA+El+Shaday/@${latitude},${longitude},17z/data=!3m1!4b1!4m5!3m4!1s0x92c55f8d018fe4df:0x896f88327dc97c61!8m2!3d${latitude}!4d${longitude}`
}
